var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.01123C6.48 2.01123 2 6.49123 2 12.0112C2 17.5312 6.48 22.0112 12 22.0112C17.52 22.0112 22 17.5312 22 12.0112C22 6.49123 17.52 2.01123 12 2.01123ZM13 19.0112H11V17.0112H13V19.0112ZM15.07 11.2612L14.17 12.1812C13.45 12.9112 13 13.5112 13 15.0112H11V14.5112C11 13.4112 11.45 12.4112 12.17 11.6812L13.41 10.4212C13.78 10.0612 14 9.56123 14 9.01123C14 7.91123 13.1 7.01123 12 7.01123C10.9 7.01123 10 7.91123 10 9.01123H8C8 6.80123 9.79 5.01123 12 5.01123C14.21 5.01123 16 6.80123 16 9.01123C16 9.89123 15.64 10.6912 15.07 11.2612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.36b5481c3ebce10b01e1e00be1af1b8c.svg";
export { ForwardRef as ReactComponent };